// extracted by mini-css-extract-plugin
module.exports = {"inactive":"style_inactive__yS6Z7"};